import { useNavigate } from 'react-router-dom';
import GradientBorder from '../../ui/GradientBorder';

import Loader from '../../ui/Loader';
import WhiteCard from '../../ui/WhiteCard';

import EmptyArray from '../../ui/EmptyArray';
import { useRef } from 'react';
import { useHome } from '../../contexts/HomeContext';

const MyCollection = () => {
    const navigate = useNavigate();
    const { state: homeState, dispatch, loading } = useHome();
    const scrollCards = useRef();
    const { greenPillNFTsHoldByWalletAddress } = homeState;
    console.log(greenPillNFTsHoldByWalletAddress, 'nftsHoldByWalletAddress');
    return (
        <div className=" mt-7 ">
            <div className="">
                <div className="relative ">
                    <h1
                        className="text-3xl font-semibold text-[white]"
                        style={{
                            textShadow: '0px 0px 11.8px rgba(255, 255, 255, 0.59)',
                        }}
                    >
                        {'My collection'}
                    </h1>
                    <GradientBorder
                        radiusBorder=".4rem"
                        color1="rgba(105, 159, 132, 1)"
                        color2="rgba(80, 108, 102, 0)"
                        isNoBottomRadius={false}
                        width="w-full"
                        bg="bg-background"
                        upperPadding="p-6"
                        borderThickness="1px"
                        className="mt-3"
                    >
                        <WhiteCard
                            bg={'bg-[#081B17]'}
                            verticalMargin=""
                            ref={scrollCards}
                            className="p-5  flex items-center overflow-x-auto   flex-nowrap   scrollableCards"
                        >
                            {loading ? (
                                <div className="h-52 w-full flex items-center justify-center">
                                    <Loader color={'fill-[#326F58]'} />
                                </div>
                            ) : greenPillNFTsHoldByWalletAddress.length > 0 ? (
                                greenPillNFTsHoldByWalletAddress.map((nft) => {
                                    return (
                                        <div
                                            onClick={() => {
                                                navigate(
                                                    `fund?nft=${
                                                        nft?.collectionNo?.toString() + nft?.tokenId?.toString()
                                                    }`
                                                );

                                                dispatch({
                                                    type: 'home/setActiveCollection',
                                                    payload: nft?.collectionNo,
                                                });
                                            }}
                                            key={nft?.collectionNo + Math.random()}
                                            className={`container cursor-pointer flex flex-col gap-[.375rem]  rounded-lg w-48  bg-[#0E2822] py-4  mr-5`}
                                        >
                                            <div className="flex items-center w-48 relative  justify-center">
                                                <img
                                                    className="w-[1.6rem] h-[1.6rem] absolute top-0 right-3 "
                                                    src={nft?.chainImage}
                                                    alt="chain-image"
                                                />
                                                <img className="w-full" src={nft?.imageURI} alt="greenpill-card" />
                                            </div>

                                            {/* <div className="w-[80%] mx-auto">progress</div> */}
                                        </div>
                                    );
                                })
                            ) : (
                                <EmptyArray />
                            )}
                        </WhiteCard>
                    </GradientBorder>

                    {/* <Button
onClick={scrollL}
className="bg-white absolute top-[50%] translate-y-[-50%]  left-4 "
variant="tertiary"
size="circle"
>
<ArrowLeft />
</Button> */}

                    {/* <Button
onClick={scrollR}
className="bg-white absolute top-[50%] translate-y-[-50%]  right-4 "
variant="tertiary"
size="circle"
>
<ArrowRight />
</Button> */}
                </div>
            </div>
        </div>
    );
};

export default MyCollection;
